<template>
  <UiComponentWrapper class="page">
    <!-- Background > Light Rays -->
    <UiComponentWrapper class="background">
      <Transition @enter="onBackgroundEnter">
        <iframe
          v-if="!$device.isMobile && backgroundIsDisplayed"
          src="data:text/html;base64,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"
          :style="{
            border: 0,
            height: `${screenWidth}px`,
            margin: 0,
            width: `${screenWidth}px`,
          }"
        />
      </Transition>
    </UiComponentWrapper>

    <!-- Section > Hero -->
    <UiComponentContainer class="hero">
      <UiComponentWrapper class="inner">
        <NuxtLink
          class="back"
          :to="localePath('webinar-tools')"
        >
          <UiComponentIcon
            theme="dark"
            type="arrow-left"
          />
          {{ props.hub.sharedWordingBackToTheHub }}
        </NuxtLink>
        <UiComponentHeading theme="dark">
          {{ props.page.heroTitle }}
        </UiComponentHeading>
        <UiComponentParagraph theme="dark">
          {{ props.page.heroText }}
        </UiComponentParagraph>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > Tool -->
    <UiComponentContainer class="tool">
      <UiComponentWrapper class="main">
        <UiComponentWrapper class="visualizer">
          <audio
            ref="$audio"
            @ended="onEnded"
          />
          <UiComponentWrapper
            class="waves"
          >
            <UiComponentWrapper
              v-for="(value, index) in soundWaves"
              :key="`wave-${index}`"
              class="wave"
              :style="{ height: `calc(100% * ${value})` }"
            />
          </UiComponentWrapper>
          <Transition @leave="onLeave">
            <UiComponentIcon
              v-if="['start'].includes(currentStage)"
              type="room-mic-off"
            />
          </Transition>
        </UiComponentWrapper>
        <UiComponentWrapper class="info">
          <UiComponentWrapper
            class="item"
            @click="scrollToSection('seo-items')"
          >
            <UiComponentIcon
              theme="dark"
              type="help-circle"
            />
            <UiComponentParagraph
              theme="dark"
              size="s"
            >
              {{ props.page.heroHelpText }}
            </UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="item">
            <UiComponentIcon
              theme="dark"
              type="code"
            />
            <UiComponentParagraph
              theme="dark"
              size="s"
            >
              {{ props.page.heroEmbedText }}
            </UiComponentParagraph>
          </UiComponentWrapper>
        </UiComponentWrapper>
      </UiComponentWrapper>
      <UiComponentWrapper class="aside">
        <Transition
          mode="out-in"
          @enter="onEnter"
          @leave="onLeave"
        >
          <UiComponentWrapper
            v-if="['success'].includes(currentStage)"
            class="message"
          >
            <UiComponentIcon
              theme="dark"
              type="check"
            />
            <UiComponentParagraph theme="dark">
              {{ props.page.heroLastStepSuccessText }}
            </UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper
            v-else-if="['error'].includes(currentStage)"
            class="message"
          >
            <UiComponentIcon
              theme="dark"
              type="x"
            />
            <UiComponentParagraph theme="dark">
              {{ props.page.heroLastStepErrorText }}
            </UiComponentParagraph>
          </UiComponentWrapper>
        </Transition>

        <UiComponentWrapper class="actions">
          <UiComponentWrapper class="buttons">
            <AtomButton
              v-if="['start'].includes(currentStage)"
              action="Button clicked"
              :attributes="{
                action: 'Start the test',
              }"
              label="Header section CTA"
              size="l"
              theme="dark"
              @click="startRecording"
            >
              <UiComponentIcon
                theme="dark"
                type="room-mic"
              />
              {{ props.page.heroFirstStepCtaWording }}
            </AtomButton>
            <AtomButton
              v-else-if="['recording'].includes(currentStage)"
              disabled
              size="l"
              theme="dark"
            >
              <UiComponentIcon
                theme="dark"
                type="room-record"
              />
              {{ props.page.heroRecordingStepCtaWording }}
            </AtomButton>
            <AtomButton
              v-else-if="['success'].includes(currentStage) && !isReplayingAudio"
              action="Button clicked"
              :attributes="{
                action: 'Play recording',
              }"
              label="Header section CTA"
              size="l"
              theme="dark"
              @click="playRecording"
            >
              <UiComponentIcon
                theme="dark"
                type="play"
              />
              {{ props.page.heroLastStepPlayCtaWording }}
            </AtomButton>
            <AtomButton
              v-else-if="['success'].includes(currentStage) && isReplayingAudio"
              size="l"
              :style="{ '--progress': `${variables.progress}%` }"
              theme="dark"
              @click="pauseRecording"
            >
              <UiComponentIcon
                theme="dark"
                type="square"
              />
              {{ props.page.heroLastStepStopCtaWording }}
            </AtomButton>
            <AtomButton
              v-if="['error', 'success'].includes(currentStage)"
              action="Button clicked"
              :attributes="{
                action: 'Start again',
              }"
              label="Header section CTA"
              size="l"
              theme="dark"
              type="secondary"
              @click="startRecording"
            >
              <UiComponentIcon
                theme="dark"
                type="refresh-cw"
              />
              {{ props.page.heroLastStepRestartCtaWording }}
            </AtomButton>
          </UiComponentWrapper>
          <UiComponentParagraph
            size="s"
            theme="dark"
          >
            {{ props.page.heroFirstStepCtaInformation }}
          </UiComponentParagraph>
        </UiComponentWrapper>

        <UiComponentWrapper class="privacy">
          <UiComponentIcon
            theme="dark"
            type="room-lock"
          />
          <UiComponentParagraph
            size="s"
            theme="dark"
          >
            {{ props.page.heroFirstStepPrivacyTitle }}
          </UiComponentParagraph>
          <UiComponentParagraph
            size="s"
            theme="dark"
          >
            {{ props.page.heroFirstStepPrivacyText }}
          </UiComponentParagraph>
        </UiComponentWrapper>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > How to Test -->
    <UiComponentContainer class="how-to-test">
      <UiComponentHeading
        :level="2"
        theme="dark"
      >
        {{ props.page.howToTestYourMicrophoneTitle }}
      </UiComponentHeading>
      <UiComponentWrapper class="list">
        <UiComponentWrapper
          v-for="{ id, image, number, text } in props.page.howToTestYourMicrophoneItems"
          :key="`how-to-test-${id}`"
          class="item"
        >
          <UiComponentWrapper class="illustration">
            <UiComponentImage
              v-if="image"
              :alt="image.alt"
              :expected-size="howToTestImageWidth"
              :height="image.height"
              :source="image.url"
              :width="image.width"
            />
            <UiComponentWrapper class="step">
              {{ number }}
            </UiComponentWrapper>
          </UiComponentWrapper>
          <UiComponentParagraph theme="dark">
            {{ text }}
          </UiComponentParagraph>
        </UiComponentWrapper>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > About us -->
    <UiComponentContainer
      class="about-us"
      :start="1"
      :end="1"
    >
      <UiComponentHeading
        :level="2"
        theme="dark"
      >
        {{ props.page.aboutUsTitle }}
      </UiComponentHeading>
      <UiComponentParagraph theme="dark">
        {{ props.componentReviews.text }}
      </UiComponentParagraph>
      <UiComponentWrapper class="our-customers">
        <UiComponentWrapper
          v-for="{ id, logo } in customers"
          :key="`logo-${id}`"
          class="logo"
        >
          <UiComponentImage
            :alt="logo.alt"
            :expected-size="24"
            :extra-params="{
              con: 100,
              gam: 100,
              monochrome: '000000',
              sat: -100,
              trim: 'color',
              vib: 100,
            }"
            :height="logo.height"
            :orientation="logo.width >= logo.height ? 'portrait' : 'landscape'"
            :source="logo.url"
            use-natural-height
            use-natural-width
            :width="logo.width"
          />
        </UiComponentWrapper>
      </UiComponentWrapper>
      <UiComponentWrapper class="our-features">
        <UiComponentWrapper
          v-for="feature in props.page.aboutUsOurFeatures"
          :key="feature.id"
          class="feature"
        >
          <UiComponentWrapper class="illustration">
            <UiComponentImage
              :alt="feature.image.alt"
              :height="feature.image.height"
              :expected-size="416"
              :source="feature.image.url"
              :width="feature.image.width"
            />
          </UiComponentWrapper>
          <UiComponentWrapper class="content">
            <UiComponentHeading
              :level="3"
              theme="dark"
            >
              {{ feature.title }}
            </UiComponentHeading>
            <UiComponentHeading
              as="paragraph"
              :level="6"
              theme="dark"
            >
              {{ feature.text }}
            </UiComponentHeading>
            <AtomButton
              :action="signupOrUpgradeCallToAction.action"
              label="Benefits section CTA"
              :to="signupOrUpgradeCallToAction.to"
              size="l"
              theme="dark"
            >
              {{ signupOrUpgradeCallToAction.slot }}
            </AtomButton>
          </UiComponentWrapper>
        </UiComponentWrapper>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > Content (SEO Items) -->
    <UiComponentContainer
      v-if="props.page.seoItems.length > 0"
      class="seo-items"
      :start="1"
      :end="1"
    >
      <UiComponentWrapper class="list">
        <UiComponentWrapper
          v-for="{ id, title, titleLevel, text, image, video } in props.page.seoItems"
          :key="`seo-item-${id}`"
          class="item"
        >
          <UiComponentHeading
            :level="titleLevel || 2"
            theme="dark"
          >
            {{ title }}
          </UiComponentHeading>
          <div
            class="text"
            v-html="$md.render(text)"
          />
          <UiComponentWrapper
            v-if="image"
            class="image"
          >
            <UiComponentWrapper class="inner">
              <UiComponentImage
                :key="`seo-item-${id}-image-${seoItemImageSize}`"
                :alt="image.alt"
                :expected-size="seoItemImageSize"
                :height="image.height"
                :orientation="image.width >= image.height ? 'landscape' : 'portrait'"
                :source="image.url"
                :width="image.width"
              />
            </UiComponentWrapper>
          </UiComponentWrapper>
          <UiComponentWrapper
            v-if="video && video.provider === 'youtube'"
            class="video"
          >
            <UiComponentWrapper class="inner">
              <iframe
                :src="`https://www.youtube.com/embed/${video.providerUid}`"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              />
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > Try our Other Tools -->
    <UiComponentContainer class="try-our-tools">
      <UiComponentHeading
        :level="2"
        theme="dark"
      >
        {{ props.page.tryOurOtherToolsTitle }}
      </UiComponentHeading>
      <UiComponentWrapper class="list">
        <AtomAnchor
          v-for="{ id, animation, title, text, to } in props.page.tryOurOtherToolsItems"
          :key="`grid-item-${id}`"
          class="item"
          :to="to"
          @click="
            track('Button clicked', {
              action: to,
              category: 'Button',
              label: 'Try our other tools section CTA',
              locale,
            })
          "
          @mouseenter="onMouseEnter"
          @mouseleave="onMouseLeave"
        >
          <UiComponentWrapper class="animation">
            <Transition @enter="onEnter">
              <lottie-player
                v-if="isLottieFrameworkLoaded"
                class="lottie"
                :src="animation.url"
              />
            </Transition>
          </UiComponentWrapper>
          <UiComponentHeading
            :level="5"
            theme="dark"
          >
            {{ title }}
          </UiComponentHeading>
          <UiComponentParagraph theme="dark">
            {{ text }}
          </UiComponentParagraph>
        </AtomAnchor>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > FAQ -->
    <UiComponentContainer
      v-if="props.page.faqItems.length > 0"
      class="faq"
      :start="1"
      :end="1"
    >
      <UiComponentHeading
        :level="2"
        theme="dark"
      >
        {{ props.page.faqTitle || props.componentGlobal.faqTitle }}
      </UiComponentHeading>
      <OrganismAccordion
        class="list"
        :items="displayedFaqItems"
        theme="dark"
      />
      <AtomButton
        v-if="props.page.faqItems.length > 5"
        theme="dark"
        to="#"
        type="secondary"
        @click="toggleFaqItems"
      >
        {{
          showMoreFaqItems
            ? props.componentGlobal.faqShowLessQuestions
            : props.componentGlobal.faqShowMoreQuestions
        }}
      </AtomButton>
    </UiComponentContainer>

    <!-- Section > Create an Account -->
    <OrganismCreateAnAccount
      :component-global="props.componentGlobal"
      :request-demo-call-to-action="requestDemoCallToAction"
      :signup-or-upgrade-call-to-action="signupOrUpgradeCallToAction"
      :text="props.componentCreateAFreeAccount.text"
      theme="dark"
      :title="props.componentCreateAFreeAccount.title"
    />
  </UiComponentWrapper>
</template>

<script setup>
// Imports
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

// Composables
const { track } = useAnalyticsJS()
const { isLogged } = useIsLoggedIn()
const localePath = useLocalePath()
const { $md } = useMarkdown()
const { $lottiePlayer } = useNuxtApp()
const { public: publicRuntimeConfig } = useRuntimeConfig()
const { width: screenWidth } = useScreenSize()

// Props
const props = defineProps({
  componentCreateAFreeAccount: {
    required: true,
    type: Object,
  },
  componentGlobal: {
    required: true,
    type: Object,
  },
  componentReviews: {
    required: true,
    type: Object,
  },
  hub: {
    required: true,
    type: Object,
  },
  page: {
    required: true,
    type: Object,
  },
})

// Refs
const $audio = ref(null)
const backgroundIsDisplayed = ref(false)
const currentStage = ref('start')
const duration = ref(6)
const isLottieFrameworkLoaded = ref(false)
const isReplayingAudio = ref(false)
const lastTime = ref(null)
const numberOfMilliseconds = ref(0)
const recorder = ref(null)
const requestAnimationFrameHandle = ref(null)
const showMoreFaqItems = ref(false)
const soundWaves = ref([0.04, 0.04, 0.09, 0.21, 0.68, 0.81, 1, 0.81, 0.44, 0.23, 0.51, 0.62, 1, 0.9, 0.93, 0.86, 0.63, 0.4, 0.2, 0.24, 0.16, 0.32, 0.54, 0.79, 0.7, 0.92, 0.68, 0.81, 1, 0.81, 0.44, 0.37, 0.26, 0.31, 0.12, 0.17, 0.27, 0.23, 0.51, 0.62, 1, 0.9, 0.93, 0.86, 0.63, 0.4, 0.2, 0.24, 0.16, 0.32, 0.54, 0.79, 0.7, 0.92, 0.46, 0.27, 0.14, 0.1, 0.04, 0.04])
const variables = ref({ progress: 0 })

// Computed Properties
const customers = computed(() => {
  return props.page.aboutUsOurCustomers
    .filter(({ logo }) => !!logo)
})

const displayedFaqItems = computed(() => {
  const index = showMoreFaqItems.value ? props.page.faqItems.length : 5
  return props.page.faqItems.slice(0, index).map(item => ({
    content: item.text,
    title: item.title,
  }))
})

const howToTestImageWidth = computed(() => {
  switch (true) {
    case screenWidth.value < 768:
      return screenWidth.value - 32
    case screenWidth.value >= 768 && screenWidth.value < 1328:
      return 530
    default:
      return 416
  }
})

const requestDemoCallToAction = computed(() => {
  return {
    action: 'Demo clicked',
    slot: props.componentGlobal.ctaGetDemo,
    to: '#form-demo',
  }
})

const seoItemImageSize = computed(() => {
  switch (true) {
    case screenWidth.value < 768:
      return screenWidth.value - 32
    case screenWidth.value >= 768 && screenWidth.value < 1328:
      return Math.min(632, Math.max(0, screenWidth.value))
    default:
      return 632
  }
})

const signupOrUpgradeCallToAction = computed(() => {
  return isLogged.value
    ? {
        action: 'Upgrade clicked',
        to: `https://${publicRuntimeConfig.appBaseUrl}/#/settings?page=settings&tab=billing`,
        slot: props.componentGlobal.ctaUpgradeNow,
      }
    : {
        action: 'Signup clicked',
        to: `https://${publicRuntimeConfig.appBaseUrl}/#/signup`,
        slot: props.componentGlobal.ctaGetStartedForFree,
      }
})

// Watchers
watch(
  () => isReplayingAudio.value,
  () => {
    gsap.fromTo(
      variables.value,
      {
        progress: 0,
      },
      {
        duration: duration.value,
        ease: 'none',
        progress: 100,
      },
    )
  },
)

// Methods
function cancelRequestAnimationFrame() {
  window.cancelAnimationFrame(requestAnimationFrameHandle.value)
  requestAnimationFrameHandle.value = null
}

function onBackgroundEnter(el, done) {
  gsap.fromTo(el, {
    autoAlpha: 0,
  }, {
    autoAlpha: 0.4,
    duration: 1,
    ease: 'expo.inOut',
    onComplete() {
      done()
    },
  })
}

function onDataAvailable(event) {
  $audio.value.setAttribute('src', window.URL.createObjectURL(event.data))
}

function onEnded() {
  isReplayingAudio.value = false
}

function onEnter(el, done) {
  gsap.from(el, {
    autoAlpha: 0,
    duration: 0.6,
    ease: 'expo.inOut',
    onComplete() {
      done()
    },
  })
}

function onInit() {
  isLottieFrameworkLoaded.value = true
}

function onLeave(el, done) {
  gsap.to(el, {
    autoAlpha: 0,
    duration: 0.6,
    ease: 'expo.inOut',
    onComplete() {
      done()
    },
  })
}

function onMouseEnter({ target }) {
  const player = target.querySelector('.page lottie-player')
  if (player) {
    player.setDirection(1)
    player.play()
  }
}

function onMouseLeave({ target }) {
  const player = target.querySelector('.page lottie-player')
  if (player) {
    player.setDirection(-1)
    player.play()
  }
}

function pauseRecording() {
  $audio.value.pause()
  nextTick(() => {
    isReplayingAudio.value = false
  })
}

function playRecording() {
  isReplayingAudio.value = true
  nextTick(() => {
    $audio.value.currentTime = 0
    $audio.value.play()
  })
}

function requestAnimationFrame(analyser, array) {
  analyser.getByteFrequencyData(array)

  const $waves = [...document.querySelectorAll('.page .wave')]
  const currentTime = new Date().getTime()
  const index = Math.floor(numberOfMilliseconds.value / ((duration.value * 1000) / $waves.length))
  const volume = Math.floor((Math.max(...array) / 255) * 100) / 100
  const amplitude = document.querySelector('.page .visualizer').offsetHeight
  const margin = screenWidth.value < 768 ? 48 : 64
  const height = (amplitude - margin) * volume

  gsap.set($waves[index], {
    backgroundColor: `rgba(255,255,255,${0.1 + (volume / 4)})`,
    height: height < 4 ? 4 : height,
  })

  numberOfMilliseconds.value += currentTime - lastTime.value
  lastTime.value = currentTime
  if (numberOfMilliseconds.value >= (duration.value * 1000)) {
    cancelRequestAnimationFrame()
    stopRecording()
  }
  else {
    requestAnimationFrameHandle.value = window.requestAnimationFrame(() => {
      requestAnimationFrame(analyser, array)
    })
  }
}

async function startRecording() {
  $audio.value.src = null
  numberOfMilliseconds.value = 0
  recorder.value?.removeEventListener('dataavailable', onDataAvailable)
  recorder.value = null

  try {
    if (navigator?.mediaDevices?.getUserMedia) {
      const stream = await navigator?.mediaDevices?.getUserMedia({ audio: true })
      if (stream) {
        recorder.value = new MediaRecorder(stream)
        recorder.value.addEventListener('dataavailable', onDataAvailable)
        recorder.value.start()

        const context = new AudioContext()
        const analyser = context.createAnalyser()
        const source = context.createMediaStreamSource(stream)
        const array = new Uint8Array(analyser.frequencyBinCount)
        source.connect(analyser)

        gsap.to(document.querySelectorAll('.page .wave'), {
          backgroundColor: '#333D41',
          duration: 0.6,
          ease: 'expo.inOut',
          height: 4,
          onComplete() {
            currentStage.value = 'recording'
            lastTime.value = new Date().getTime()
            requestAnimationFrame(analyser, array)
          },
        })
      }
      else {
        currentStage.value = 'error'
      }
    }
    else {
      currentStage.value = 'error'
    }
  }
  catch (error) {
    currentStage.value = 'error'
  }
}

function stopRecording() {
  cancelRequestAnimationFrame()
  currentStage.value = 'success'
  recorder.value.stop()
  recorder.value.stream.getTracks().forEach(t => t.stop())
}

function scrollToSection(value) {
  const y = `.${value}`
  gsap.to(window, {
    duration: 1,
    ease: 'expo.inOut',
    scrollTo: {
      offsetY: screenWidth.value > 1328 ? 104 : 80,
      y,
    },
  })
}

function toggleFaqItems() {
  showMoreFaqItems.value = !showMoreFaqItems.value
}

// Lifecycle Hooks
onBeforeUnmount(() => {
  if (requestAnimationFrameHandle.value) {
    cancelRequestAnimationFrame()
  }
})

onMounted(() => {
  $lottiePlayer.init(onInit)
  nextTick(() => {
    backgroundIsDisplayed.value = true
  })
})
</script>

<style lang="postcss" scoped>
.page {
  @apply relative flex-col items-center bg-[#091316] overflow-x-clip;

  @screen xl {
    @apply overflow-visible;
  }

  .background {
    @apply absolute left-0 right-0 -top-[57px] w-full bg-gradient-to-b from-winter-green-900 to-[#091316] aspect-square z-0;

    @screen md {
      @apply -top-[73px];
    }
  }

  .hero {
    @apply flex-col mt-14 z-10;

    @screen md {
      @apply mt-18;
    }

    @screen xl {
      @apply mt-14;
    }

    .inner {
      @apply flex-col max-w-[956px];

      .back {
        @apply inline-flex gap-2 items-center font-medium text-white text-sm leading-6;
      }

      .h1 {
        @apply mt-6;

        & + p {
          @apply mt-2;
        }
      }
    }
  }

  .tool {
    @apply flex-col gap-8 mt-7 z-10;

    @screen md {
      @apply gap-10 mt-18;
    }

    @screen xl {
      @apply flex-row flex-wrap gap-0 items-center justify-between mt-22;
    }

    .main {
      @apply flex-col gap-4;

      @screen xl {
        @apply w-[740px];
      }

      .visualizer {
        @apply relative h-[104px] bg-[#0E1C20] border border-[#333D41] rounded-2xl backdrop-blur-md overflow-hidden;

        @screen md {
          @apply h-[256px];
        }

        audio {
          @apply hidden;
        }

        .waves {
          @apply relative self-center items-center justify-around h-[51.2px];

          @screen md {
            @apply h-[107px];
          }

          @screen xl {
            @apply h-[111px];
          }

          .wave {
            @apply h-full w-px bg-[#333D41] rounded-full;

            @screen md {
              @apply w-0.5;
            }
          }
        }

        .icon {
          @apply absolute inset-1/2 h-10 w-10 text-white/50 text-4xl leading-none transform -translate-x-1/2 -translate-y-1/2;

          @screen md {
            @apply h-20 w-20 text-[80px];
          }
        }
      }

      .info {
        @apply flex-col;

        @screen md {
          @apply flex-row justify-between;
        }

        .item {
          @apply gap-2 items-center w-auto cursor-pointer;

          &:hover {
            p {
              @apply underline underline-offset-2;
            }
          }

          &:nth-child(2) {
            @apply hidden;
          }

          p {
            @apply text-white;
          }
        }
      }
    }

    .aside {
      @apply flex-col gap-8;

      @screen xl {
        @apply w-[416px];
      }

      .message {
        @apply items-center gap-2 p-8 bg-white/5 rounded-2xl;

        .icon {
          @apply h-6 w-6 text-2xl leading-none;
        }

        p {
          @apply text-base leading-6;
        }
      }

      .actions {
        @apply flex-col gap-2;

        @screen xl {
          @apply gap-4;
        }

        .buttons {
          @apply flex-col gap-4;

          @screen md {
            @apply flex-row flex-wrap;
          }

          .button {
            &.primary {
              @apply relative overflow-hidden;

              &::after {
                @apply absolute bottom-0 left-0 top-0 w-[var(--progress)] bg-white/10 content-[''];
              }
            }

            &.secondary {
              @apply bg-transparent border border-[#5D6669] text-white;

              &:hover {
                @apply bg-white/5;
              }
            }
          }
        }

        .button {
          @apply gap-2;

          @screen xl {
            @apply self-start;
          }
        }
      }

      .privacy {
        @apply relative flex-col p-4 pl-10 bg-[#0E1C20] border border-[#333D41] rounded-xl;

        .icon {
          @apply absolute top-4 left-4;
        }

        p {
          @apply font-medium text-white;

          & + p {
            @apply mt-1 font-normal leading-[22px];
          }
        }
      }
    }
  }

  .how-to-test {
    @apply flex-col items-center gap-8 mt-26 z-10;

    @screen md {
      @apply mt-40;
    }

    .h2 {
      @apply text-center;
    }

    .list {
      @apply flex-col items-center gap-8;

      @screen xl {
        @apply flex-row flex-wrap items-start gap-4;
      }

      .item {
        @apply flex-col items-center gap-6 max-w-[530px];

        @screen xl {
          width: calc((100% - 32px) / 3);
        }

        .illustration {
          @apply relative bg-[#0C181D] border border-[#333D41] rounded-2xl backdrop-blur-md aspect-[416/232] overflow-hidden;
          box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.40), 0px 16px 32px 0px rgba(13, 22, 38, 0.10), 0px 8px 16px 0px rgba(13, 22, 38, 0.10), 0px 4px 8px 0px rgba(13, 22, 38, 0.10), 0px 2px 4px 0px rgba(13, 22, 38, 0.10), 0px 1px 2px 0px rgba(13, 22, 38, 0.10);

          .step {
            @apply absolute left-4 top-4 flex items-center justify-center h-10 w-10 p-2 bg-white font-medium text-winter-green-900 text-xl leading-[normal] rounded-lg;
          }
        }

        p {
          @apply text-center;
        }
      }
    }
  }

  .about-us {
    @apply flex-col items-center mt-26 z-10;

    @screen md {
      @apply mt-50;
    }

    .h2 {
      @apply text-center;

      & + p {
        @apply mt-8 text-center;
      }
    }

    .our-customers {
      @apply flex-wrap justify-center gap-x-10 gap-y-6 w-auto mt-4;

      .logo {
        @apply justify-center h-6 w-auto;

        picture {
          @apply rounded-none;
          filter: brightness(0) saturate(100%) invert(80%) sepia(7%) saturate(83%) hue-rotate(149deg) brightness(92%) contrast(91%);
        }
      }
    }

    .our-features {
      @apply flex-col gap-[104px] mt-20;

      .feature {
        @apply flex-col gap-6;

        @screen xl {
          @apply flex-row flex-wrap items-center justify-between gap-0;
        }

        &:nth-child(odd) {
          .content {
            @screen xl {
              @apply order-first;
            }
          }
        }

        .illustration {
          @apply justify-center;

          @screen xl {
            @apply max-w-[416px];
          }

          picture {
            @apply rounded-none;
          }
        }

        .content {
          @apply flex-col gap-4;

          @screen xl {
            @apply max-w-[524px];
          }

          .h6 {
            @apply font-normal text-[#CED0D0];

            :deep(strong) {
              @apply font-medium text-white;
            }
          }

          .button {
            @apply self-start mt-4;
          }
        }
      }
    }
  }

  .seo-items {
    @apply mt-26 z-10;

    @screen md {
      @apply mt-50;
    }

    .list {
      @apply flex-col gap-10;

      .item {
        @apply flex-col gap-4;

        :deep(.text) {
          @apply flex flex-col gap-4 text-[#CED0D0] text-base leading-[26px];

          a {
            @apply text-white underline underline-offset-2;
          }

          b,
          strong {
            @apply font-medium text-white;
          }

          ol {
            @apply flex flex-col gap-4 marker:font-medium marker:text-white;

            li {
              @apply font-normal text-[#CED0D0] text-base leading-[26px] list-decimal list-inside;
            }
          }

          ul {
            @apply flex flex-col gap-4 marker:font-medium marker:text-white;

            li {
              @apply block font-normal text-[#CED0D0] text-base leading-[26px];

              &:before {
                @apply inline-block w-3 h-3 bg-white mr-3;
                border-radius: 3px;
                content: "";
              }
            }
          }
        }

        .image {
          @apply justify-center mt-10;

          .inner {
            @apply relative max-w-[632px] bg-grey-blue-100 rounded-4xl overflow-hidden;
          }
        }

        .video {
          @apply justify-center mt-10;

          .inner {
            @apply relative max-w-[632px] bg-grey-blue-100 aspect-video rounded-4xl overflow-hidden;

            iframe {
              @apply absolute h-full w-full flex;
            }
          }
        }
      }
    }
  }

  .try-our-tools {
    @apply flex-col items-center gap-8 mt-26 z-10;

    @screen md {
      @apply mt-50;
    }

    .h2 {
      @apply font-medium text-center text-2xl leading-8;

      @screen mdminus {
        @apply text-[28px] leading-[34px];
      }

      @screen mdplus {
        @apply text-3xl leading-10;
      }
    }

    .list {
      @apply flex-col gap-4;

      @screen md {
        @apply flex-row flex-wrap;
      }

      .item {
        @apply flex-col p-8 bg-[#0C181D] border border-[#333D41] rounded-2xl backdrop-blur-md transition-colors duration-500 ease-in-out;

        @screen md {
          width: calc((100% - 16px) / 2);
        }

        @screen xl {
          width: calc((100% - 32px) / 3);
        }

        &:hover {
          @apply bg-[#0E1C20] border-[#5D6669]
        }

        .animation {
          @apply justify-center h-[154px];
        }

        .h5 {
          @apply mt-4;

          & + p {
            @apply mt-2 text-sm leading-6;
          }
        }
      }
    }
  }

  .faq {
    @apply flex-col items-center gap-10 mt-26 z-10;

    @screen md {
      @apply mt-50;
    }
  }

  .create-an-account {
    @apply z-10;
  }
}
</style>
